import { render, staticRenderFns } from "./ObjectTypeEditor.vue?vue&type=template&id=3d8b63de&"
import script from "./ObjectTypeEditor.vue?vue&type=script&lang=js&"
export * from "./ObjectTypeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTypeEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports